import { Controller } from '@hotwired/stimulus';
import CurrentPage from '@frontend/app/features/CurrentPage';
import CurrentUser from '@frontend/app/features/CurrentUser';
import { loadAndDisplay as loadAndDisplayInModal } from '@controllers/main/modal-window_controller';
import { show } from '@frontend/utils/dom';
import { dispatchCustomEvent } from '@frontend/utils/events';

export default class extends Controller {
  static values = {
    articleId: Number,
    shareModalUrl: String,
    hasPaywall: Boolean,
  };

  static targets = [
    'markdownContent',
    'shareUrlPromotionSubscriber',
    'shareUrlPromotionTopbar',
    'shareUrlPromotionTopbarMessageNoAuthor',
    'shareUrlPromotionTopbarMessageWithAuthor',
    'shareUrlPromotionTopbarMessageAuthor',
  ];

  connect() {
    document.body.addEventListener(
      'article:display-share-url-promotion-topbar',
      this.showShareUrlPromotionTopbar.bind(this)
    );

    this.displayShareUrlPromotionForSubscribers();
    this.scrollToCommentsWhenDeepLinkingToComment();
  }

  showShareUrlPromotionTopbar() {
    show(this.shareUrlPromotionTopbarTarget);

    const shareUrl = CurrentPage.getShareUrl();
    if (shareUrl.sharedBy) {
      this.shareUrlPromotionTopbarMessageAuthorTarget.innerHTML =
        shareUrl.sharedBy;
      show(this.shareUrlPromotionTopbarMessageWithAuthorTarget);
    } else {
      show(this.shareUrlPromotionTopbarMessageNoAuthorTarget);
    }
  }

  showShareUrlModal() {
    loadAndDisplayInModal(this.shareModalUrlValue);
  }

  displayShareUrlPromotionForSubscribers() {
    if (
      !this.hasPaywallValue ||
      !CurrentUser.isSubscriber() ||
      CurrentUser.isEditor() ||
      CurrentUser.isAdmin() ||
      !this.hasShareUrlPromotionSubscriberTarget
    )
      return false;

    show(this.shareUrlPromotionSubscriberTarget);
    document.documentElement.style.setProperty(
      '--share-url-promotion-subscriber-height',
      `${this.shareUrlPromotionSubscriberTarget.offsetHeight}px`
    );
  }

  scrollToCommentsWhenDeepLinkingToComment() {
    if(window.location.hash.match(/#comment-(\d+)/)) {
      document.querySelector('#comments').scrollIntoView();
    }
  }
}

export function displayShareUrlPromotionTopbar() {
  dispatchCustomEvent('article:display-share-url-promotion-topbar');
}
